import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ShoppingService} from '@app/shopping/shopping.service';
import {ShoppingPromotionComponent} from '@app/shopping-promotion/shopping-promotion.component';
import {ShoppingPromotionNfComponent} from '@app/shopping-promotion-nf/shopping-promotion-nf.component';
import {ShoppingPromotionNfFormComponent} from '@app/shopping-promotion-nf-form/shopping-promotion-nf-form.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ShoppingPromotionRoutingModule} from '@app/shopping-promotion/shopping-promotion-routing.module';
import {NgxMaskModule} from 'ngx-mask';
import {ShoppingPromotionLotteryComponent} from '@app/shopping-promotion-lottery/shopping-promotion-lottery.component';
import {YoutubePlayerModule} from 'ngx-youtube-player';
import {SearchPipe} from '@app/core/pipe/search.pipe';
import {AngularFireModule} from 'angularfire2';
import {environment} from '@env/environment';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    CoreModule,
    SharedModule,
    ShoppingPromotionRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxMaskModule.forRoot(),
    YoutubePlayerModule,
    AngularFireModule.initializeApp(environment.firebase),
  ],
  declarations: [
    ShoppingPromotionComponent,
    ShoppingPromotionNfComponent,
    ShoppingPromotionNfFormComponent,
    ShoppingPromotionLotteryComponent,
  ],
  providers: [
    ShoppingService
  ]

})
export class ShoppingPromotionModule { }



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shopping-promotion/shopping-promotion.module.ts